export const CONTENT = 'bgdf.normal.content';
export const TITLE = 'bgdf.normal.title';
export const EMAIL_LABEL = 'bgdf.email.label';
export const NAME_LABEL = 'bgdf.name.label';
export const MESSAGE_LABEL = 'bgdf.message.label';
export const MESSAGE_PLACEHOLDER = 'bgdf.message.placeholder';
export const ERROR_TRY_AGAIN = 'bgdf.error.try_again';
export const ERROR_CONTENT = 'bgdf.error.content';
export const ERROR_TITLE = 'bgdf.error.title';
export const SUBMIT = 'bgdf.submit';
export const CANCEL = 'bgdf.cancel';
export const SUCCESS_CONTENT = 'bgdf.success.content';
export const SUCCESS_TITLE = 'bgdf.success.title';
export const EMAIL_VALID_ERROR = 'bgdf.email.error.valid';
export const EMAIL_REQUIRED_ERROR = 'bgdf.email.error.required';
export const FIRST_NAME_LABEL = 'bgdf.firstname.label';
export const LAST_NAME_LABEL = 'bgdf.lastname.label';
export const PHONE_NUMBER_LABEL = 'bgdf.phonenumber.label';
export const COMPANY_NAME_LABEL = 'bgdf.companyname.label';
export const QUANTITY_LABEL = 'bgdf.quantity.label';
export const OCCASION_LABEL = 'bgdf.occasion.label';
export const PRODUCTS_LABEL = 'bgdf.products.label';
export const BUSINESS_GIFTING_EMAIL = 'bgdf.businessgiftingemail.label';
export const CALL_US_DIRECTLY = 'bgdf.callusdirectly';
export const CALL_US_NUMBER = 'bgdf.callusnumber';
export const REQUIRED_ERROR = 'bgdf.requirederror';
export const FIRST_NAME_REQUIRED_ERROR = 'bgdf.firstname.required.error';
export const FIRST_NAME_VALID_ERROR = 'bgdf.firstname.valid.error';
export const LAST_NAME_REQUIRED_ERROR = 'bgdf.lastname.required.error';
export const LAST_NAME_VALID_ERROR = 'bgdf.lastname.valid.error';
export const PHONE_NUMBER_REQUIRED_ERROR = 'bgdf.phonenumber.required.error';
export const PHONE_NUMBER_VALID_ERROR = 'bgdf.phonenumber.valid.error';
export const COMPANY_NAME_REQUIRED_ERROR = 'bgdf.companyname.required.error';
export const COMPANY_NAME_VALID_ERROR = 'bgdf.companyname.valid.error';
export const QUANTITY_REQUIRED_ERROR = 'bgdf.quantity.required.error';
export const QUANTITY_VALID_ERROR = 'bgdf.quantity.valid.error';
export const QUANTITY_MIN_ERROR = 'bgdf.quantity.min.error';
export const OCCASION_REQUIRED_ERROR = 'bgdf.occasion.required.error';
export const OCCASION_VALID_ERROR = 'bgdf.occasion.valid.error';
export const PRODUCTS_VALID_ERROR = 'bgdf.products.valid.error';
export const CANT_BEGIN_WITH_O_OR_1 = 'bgdf.phone_cant_begin_with_0_or_1';
export const PLEASE_CHOOSE = 'bgdf.pleasechoose';
